import React from "react";
import { useSelector } from "react-redux";
import AchievementsCard from "./AchievementsCard";
import NotificationPopover from "../NotificationPopover";

function AchievementsAndAwards({ InternaltionalAchievementsNotification }) {
  console.log({ InternaltionalAchievementsNotification });
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );
  const AchievementsInternationalGold = userAllFormsDetails.filter((data) =>
    data.SK.includes("Achievements#International#Gold")
  );
  const AchievementsInternationalSilver = userAllFormsDetails.filter((data) =>
    data.SK.includes("Achievements#International#Silver")
  );
  const AchievementsInternationalBronze = userAllFormsDetails.filter((data) =>
    data.SK.includes("Achievements#International#Bronze")
  );
  const AchievementsNationalGold = userAllFormsDetails.filter((data) =>
    data.SK.includes("Achievements#National#Gold")
  );
  const AchievementsNationalSilver = userAllFormsDetails.filter((data) =>
    data.SK.includes("Achievements#National#Silver")
  );
  const AchievementsNationalBronze = userAllFormsDetails.filter((data) =>
    data.SK.includes("Achievements#National#Bronze")
  );
  return (
    <div className="space-y-10 relative">
      <AchievementsCard
        // AchievementType={AchievementsInternational[0].SK}
        title={
          <div className="flex justify-between">
            <p className="mr-2">International Achievements</p>
            <NotificationPopover
              notifications={InternaltionalAchievementsNotification}
            />
          </div>
        }
        gold={AchievementsInternationalGold}
        silver={AchievementsInternationalSilver}
        bronze={AchievementsInternationalBronze}
        Achievements={AchievementsInternationalGold}
        // model={AchievementsInternational[0]?.SK.split("#")[2]}
      />
      <AchievementsCard
        // AchievementType={AchievementsNational[0].SK}
        title={
          <div className="flex justify-between">
            <p className="mr-2">National Achievements</p>
            <NotificationPopover
              notifications={InternaltionalAchievementsNotification}
            />
          </div>
        }
        Achievements={AchievementsNationalGold}
        gold={AchievementsNationalGold}
        silver={AchievementsNationalSilver}
        bronze={AchievementsNationalBronze}
        // model={AchievementsNational[0]?.SK.split("#")[2]}
      />
      {/* <button className="w-full bg-tabsTextStyle rounded-3xl text-pureWhite p-2 text-lg">
        Save Changes
      </button> */}
    </div>
  );
}

export default AchievementsAndAwards;
